const s = {
  name: "DataAnalyticsTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,14V8H5v6H7z"/>
		<path class="st0" d="M15,14V6h-2v8H15z"/>
		<path class="st0" d="M11,14v-4H9v4H11z"/>
		<path class="st0" d="M0,10C0,4.5,4.5,0,10,0c5.5,0,10,4.5,10,10c0,2.4-0.8,4.6-2.3,6.3l5.7,5.7L22,23.4l-5.7-5.7
			C14.6,19.2,12.4,20,10,20C4.5,20,0,15.5,0,10z M10,2c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C18,5.6,14.4,2,10,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as DataAnalyticsTeam
};
